<template>
    <div class="wrapper">
        <b-container>
            <div class="AwardCeremony" >{{title}}</div>
            <little-bar class="nav-bar"
				v-model="current"
				:navlist="navlist"
                @changeCurrent="changeCurrent"
			>
                <template v-slot:right-nav>
                    <div>
                        <div class="year-btn" @click="showDropDown">
                            <div ><span class="span-year" style="padding-right: 2rem">{{$t('lang.years')}}：</span>{{ yearActive }}</div>
                            <b-icon class="arrow" icon="chevron-down"></b-icon>
                        </div>
                        <div v-show="show" class="drop-down" @mouseleave="show = false">
                            <div
                                class="drop-item"
                                v-for="(item, index) in year.sub"
                                :key="index"
                                @click="searchYear(item.text)"
                            >
                                {{ item.text }}
                            </div>
                        </div>
                    </div>
                </template>
            </little-bar>
            <!-- 不按日期分类 -->
            <template v-if="current != 0 && sortFlag">
                    <layoutimg class="layout-no-date" type="activity" position="left" height="15.2rem" :dataList="noSortData" :cols="12" :md="4">
                    </layoutimg>
            </template>
            <!-- 按日期分类 -->
            <template v-else>
                <div v-for="(item, index) in dealData" :key="index">
                    <layoutimg class="layout" type="activity" position="left" height="15.2rem" :dataList="item.list" :cols="12" :md="4">
                        <template v-slot:title>
                            <div class="title">{{item.year}}</div>
                        </template>
                    </layoutimg>
                </div>
            </template>
            
        </b-container>
    </div>
</template>
<script>
export default {
    data(){
        return{
            title: '',
            current: 0,
            currentId: '',
            sortFlag: true, //是否排序
			navlist: [],
			dataList: [],
			fixedData: {
				text: ' ALL',
				link: '',
            },
            show: false,
			dataNavList:[],
			year: {
				text: '年份',
				link: '',
				sub: [
					{
						text: 'ALL',
					},
				],
            },
            yearActive: 'ALL',
            dealData: [], //按日期分类的数组
            noSortData: [], //\不按日期分类
            title: ''
        }
    },
	created(){
		this.getActivitySecList(this.$route.query.type)
        this.getActivitySearch('', this.$route.query.type, '')
        this.getActivityYear()
        this.title = this.$route.query.tit
	},
	watch:{
		$route: {
			handler(val) {
                //新路由
                this.yearActive = 'ALL'
                this.getActivitySearch('', this.$route.query.type, '')
                this.getActivitySecList(val.query.type)
                this.getActivitySearch('', this.$route.query.type, '')
                this.title = this.$route.query.tit
			},
        },
        current(){
            // 切换tab栏均初始化
            this.sortFlag = true;
            this.yearActive = 'ALL'

        }
    },
    methods:{
       
        searchYear(year){
            this.yearActive = year
            this.getActivitySearch( this.yearActive == 'ALL'? '': this.yearActive,  this.$route.query.type, this.currentId)
        },
        showDropDown() {
            this.sortFlag = false;
            this.show = !this.show;
		},
        getActivityYear(){
            this.$api.activityYear()
            .then(res=>{
                let arr = res.data.map(item=>{
                    return {
                        text: item
                    }
                })
                this.year.sub.push(...arr)
                // this.year.sub = res.data
            })
        },
        changeCurrent(index, path, id){
            // console.log('二级', id)
            this.currentId = id
			this.getActivitySearch('', this.$route.query.type, id)
            this.current = index
        },
		getActivitySecList(id){
			this.$api.activitySecList({
				parentId: id
			})
			.then(res=>{
				let arr = res.data;
				this.dataNavList = arr.map(item=>{
					return {
						text: item.name,
						link: '/activity/list?type='+ this.$route.query.type,
						SecId: item.id
					}
				})
				this.navlist =  [this.fixedData],
				this.navlist.push(...this.dataNavList)
			})
		},
		getActivitySearch(year, id, secId){
			this.$api.activitySearch({
				year: year,
				categoryId: id,
				categorySecId: secId
			})
			.then(res=>{
                let arr;
                arr = res.data.map(item => {
                    return item.list
                })
                this.noSortData = arr.flat()
                this.dealData = res.data;
                // let keyArr = Object.keys(arr)
                // let valueArr = Object.values(arr)
                // let newArr = [];
                // this.dealData = valueArr.map((item, index)=>{
                //     return{
                //         name: keyArr[index],
                //         value: item
                //     }
                // })
			})
        },
       
    }
}
</script>
<style lang="scss" scoped>
.layout-no-date::v-deep{
    margin-top: 6rem;
     .layout-item{
        margin-bottom: 2.4rem;
    }
    .bottom-title{
        font-size: 1.2rem;
        padding-left: 1rem;
    }
     @media (max-width: 992px) {
         margin-top: 4rem;
        .img-wrap {
            width: 75%;
            height: 14.2rem;
        }
        .layout-item{
            margin-bottom: 2.4rem;
        }
        .bottom-title{
            display: flex;
            justify-content: center;
        }
    }
}
.layout::v-deep{

    .img-wrap {
        width: 87%;
    }
     .bottom-title{
        font-size: 1.2rem;
        padding-left: 1rem;
    }
    @media (max-width: 992px) {
        margin-top: 1.5rem;
        .title{
            font-size: 1.2rem;
            text-align: center;
            padding: 0;
        }
        .layout-item{
            margin-bottom: 1rem;
        }
        .img-wrap {
            width: 75%;
            height: 14.2rem;
        }
       
        .bottom-title{
            font-size: 1rem;
            display: flex;
            justify-content: center;
        }
    }
}
.nav-bar::v-deep{
    margin: 1rem 0 0 0 !important;
    @media (max-width: 992px)  {
        .span-year {
            display: none;
        }
    }
}
.year-btn {
    display: flex;
    padding: 0 2rem;
    align-items: center;
    cursor: pointer;
}
.drop-down {
    position: relative;
    left: 2rem;
    text-align: center;
    background-color: #fff;
    z-index: 999;
    cursor: pointer;
    line-height: 3rem;
    .drop-item:hover {
        color: #c8a063;
    }
}
.title{
    padding: 2rem 2rem;
    font-size: 2rem;
    color: $science-theme-color;
}
.AwardCeremony{
    font-size: 1.3rem;
    color: #cfaf75;
    position: relative;
    top: 22px;
    left: 7px;
}
</style>